import { combineReducers } from 'redux';
import userReducer from './reducerUser';
import configSettings from './reducerConfigSettings';
export default combineReducers({
  user: userReducer,
  configSettings:configSettings
});
